import { featureItems } from '@/mocks/cinema';

export default function SectionFeatures() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-50">
      <div className="section-container px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-100 mb-3">
            平台优势
          </h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">
            为什么千万剧迷选择夜猫电影院？五大核心优势告诉你
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {featureItems.map((item, i) => (
            <div
              key={item.title}
              className="group p-6 rounded-xl bg-background-100 border border-background-200/30 hover:border-primary-500/20 transition-all duration-200 text-center"
            >
              <div className="w-14 h-14 mx-auto mb-4 rounded-full bg-primary-500/10 flex items-center justify-center transition-transform duration-200 group-hover:scale-110">
                <i className={`${item.icon} text-2xl text-primary-400`} />
              </div>
              <h3 className="text-base font-heading text-foreground-200 mb-2 whitespace-nowrap">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}